import { Color, ColorFill, Container, SvgGraphics } from '@tencent/alloy-renderer';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { reduceWHbyRatio } from '@src/slide/infrastructure/module/independent/graphic/resize';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ShapeType } from '@src/slide/infrastructure/module/dependent/shape-info/graphic-type';
import { generateGraphicsModel } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/graphic-adapter/generate-graphics-model';
import { GraphicsRenderComponent } from '@tencent/alloy-graphics';
import { IRenderProps } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-entry/edit-pc/stable-layer/stable-layer.interface';
import { SlideSizeType } from '@src/slide/domain/ui-model/element-modeles/property/slide-size/slide-size.interface';

export class RenderArea extends Container {
    private scale: number;
    private slideModel: ISlideModel;
    private whiteBackground: SvgGraphics;
    private component: GraphicsRenderComponent;
    private handleStableLayerUpdate: (props: Partial<IRenderProps>) => void;
    private sizeType: SlideSizeType;
    private sizeWidth: number;
    private sizeHeight: number;

    public constructor(
        scale: number,
        slideModel,
        handleStableLayerUpdate: (props: Partial<IRenderProps>) => void,
    ) {
        super();
        this.slideModel = slideModel;
        this.handleStableLayerUpdate = handleStableLayerUpdate;
        // eslint-disable-next-line no-underscore-dangle
        this._addUpdateListener(this.onUpdate);
        this.scale = scale;
        this.sizeType = this.getAppServices().getUiDataService().presentation.props.slideSizeType;
        this.sizeWidth = this.getAppServices().getUiDataService().presentation.props.slideWidth;
        this.sizeHeight = this.getAppServices().getUiDataService().presentation.props.slideHeight;
    }

    /**
     * 更新需要的一些信息
     * @param scale
     */

    public updateInfo(scale: number): void {
        const { slideSizeType, slideHeight, slideWidth } = this.getAppServices().getUiDataService().presentation.props;
        if (scale === this.scale
            && slideSizeType === this.sizeType
            && slideWidth === this.sizeWidth
            && slideHeight === this.sizeHeight
        ) {
            return;
        }
        this.scale = scale;
        this.sizeType = slideSizeType;
        this.sizeWidth = slideWidth;
        this.sizeHeight = slideHeight;
        this.renderBackgroundComponent();
    }

    public renderBackgroundComponent = () => {
        this.renderWhiteBackground();
        const { newWidth: smallerSlideWidth, newHeight: smallerSlideHeight } = reduceWHbyRatio(
            this.getAppServices().getUiDataService().presentation.props.slideWidth,
            this.getAppServices().getUiDataService().presentation.props.slideHeight,
            0.2 / this.scale,
        );
        const slideBgModel = {
            ...this.slideModel.props.style,
            width: smallerSlideWidth,
            height: smallerSlideHeight,
            bgShape: ShapeType.rect,
            editable: false,
            selected: false,
            shadeTitleFrame: this.slideModel.getBackgroundFill().getShadeTitleFrame(),
        };
        const backGroundGraphicModel = generateGraphicsModel({
            style: slideBgModel,
        });
        if (!this.component) {
            this.component = new GraphicsRenderComponent(backGroundGraphicModel);
            this.addChild(this.component);
        } else {
            this.component.updateModel(backGroundGraphicModel);
        }
    };

    private onUpdate = () => {
        this.handleStableLayerUpdate?.({
            slideModel: this.slideModel,
        });
    };

    private renderWhiteBackground() {
        const { slideWidth, slideHeight } = this.getAppServices().getUiDataService().presentation.props;
        const { newWidth: smallerSlideWidth, newHeight: smallerSlideHeight } = reduceWHbyRatio(
            slideWidth,
            slideHeight,
            0.2 / this.scale,
        );
        const path = `M 0 0 L ${smallerSlideWidth} 0 L ${smallerSlideWidth} ${smallerSlideHeight} L 0 ${smallerSlideHeight} Z`;
        if (!this.whiteBackground) {
            this.whiteBackground = new SvgGraphics(path);
            this.whiteBackground.fill = new ColorFill(Color.White);
            this.addChild(this.whiteBackground);
        } else {
            this.whiteBackground.path = path;
        }
    }

    private getAppServices(): IPcEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IPcEditorAppServices;
    }
}
